import React from "react";
import PropTypes from "prop-types";
import { passwordReset } from "actions/passwordResetActions";
import { fetchPasswordPolicy } from "actions/changePasswordActions";
import PasswordResetForm from "./PasswordResetForm";
import { Card, CardSection } from "cxa-components";
import { ClientLogo } from "@cxagroup/casper";
import { camelizeKeys } from "humps";
import { connect } from "react-redux";
import lodash from "lodash";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import LogoPP from "../common/LogoPP";
import GlobalMessageBoard from "../common/global-message-board";
class PasswordResetPage extends React.Component {
  doRedirect(props = this.props) {
    const {
      user,
      isAuthenticated,
      push,
      query: { redirectTo },
    } = props;
    if (isAuthenticated) {
      const nextLocation = redirectTo
        ? decodeURI(redirectTo)
        : lodash.get(user, "websiteConfig.portal");
      if (nextLocation) {
        push(nextLocation);
      }
    }
  }

  componentDidMount() {
    const { client, fetchPasswordPolicy } = this.props;
    fetchPasswordPolicy(client && { clientName: client });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.doRedirect();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    this.doRedirect(nextProps);
  }

  render() {
    const { client, logoUrl, passwordReset, intl } = this.props;

    return (
      <div>
        <div
          style={{
            backgroundColor: "pink",
            position: "sticky",
            left: "0",
            top: "0",
            zIndex: "100",
          }}
        >
          <GlobalMessageBoard />
        </div>
        <div className="login-wrapper">
          <Card>
            <header>
              {logoUrl ? (
                <ClientLogo client={client} logoUrl={logoUrl} size="large" />
              ) : (
                <LogoPP width={240} />
              )}
              <h3>{intl.formatMessage(messages.passwordResetDescription)}</h3>
            </header>
            <p>{intl.formatMessage(messages.passwordReset.passwordResetMessage)}</p>
            <CardSection>
              <PasswordResetForm onSubmit={passwordReset} {...this.props} />
            </CardSection>
          </Card>
        </div>
      </div>
    );
  }
}

PasswordResetPage.propTypes = {
  client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  logoUrl: PropTypes.string,
  passwordReset: PropTypes.func.isRequired,
  fetchPasswordPolicy: PropTypes.func,
  initialValues: PropTypes.object,
  user: PropTypes.object,
  query: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  intl: intlShape.isRequired,
};

const mapStateToProps = (
  {
    app: { client, clientName },
    passwordReset: { response, submitting, submitted },
    changePassword: { policyDescription },
    common: { logoUrl },
  },
  { query }
) => {
  const camelizeQuery = camelizeKeys(query);
  return {
    client,
    logoUrl,
    response,
    submitting,
    submitted,
    policyDescription,
    initialValues: {
      companyId: camelizeQuery.clientID,
      requestToken: camelizeQuery.token,
    },
  };
};

const mapDispatchToProps = dispatch => ({
  passwordReset: data => dispatch(passwordReset(data)),
  fetchPasswordPolicy: data => dispatch(fetchPasswordPolicy(data)),
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PasswordResetPage)
);



// WEBPACK FOOTER //
// ./components/password/PasswordResetPage.js